import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, CircularProgress, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useAccessLevel from '../../helpers/useAccessLevel';

function Portal() {
  const navigate = useNavigate();
  const { itAccess, userAccess } = useAccessLevel();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (itAccess || userAccess) {
      navigate('/purchase-orders', { replace: true });
    } else {
      setChecked(true);
    }
  }, [itAccess, userAccess, navigate]);

  if (!checked) {
    return (
        <Container maxWidth="sm">
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 12, gap: 3 }}>
            <CircularProgress />
            <Typography variant="body2" color="text.secondary">Verifying access…</Typography>
          </Box>
        </Container>
    );
  }

  // Access denied — but if somehow the user has access (race condition / token delay),
  // show a manual navigation button as a fallback
  const hasAccess = itAccess || userAccess;

  return (
      <Container maxWidth="sm">
        <Box sx={{ textAlign: 'center', mt: 12 }}>
          <Typography variant="h4" color="primary" gutterBottom className="pageHeader">
            GRN Portal
          </Typography>

          {hasAccess ? (
              <>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 3 }}>
                  Access verified. Click below to continue.
                </Typography>
                <Button
                    variant="contained"
                    size="large"
                    onClick={() => navigate('/purchase-orders')}
                >
                  Go to Purchase Orders
                </Button>
              </>
          ) : (
              <>
                <Typography variant="h6" color="error" sx={{ mt: 2 }}>
                  Access Denied
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  You do not have permission to access this portal.
                  Please contact your IT administrator.
                </Typography>
              </>
          )}
        </Box>
      </Container>
  );
}

export default Portal;